import { Coordinate } from 'app/models/coordinate.interface';
import { BrowseTypesEnum } from '../models/browse-types.enum';
import { Playlist } from '@kinomap-dev/ng-ui-lib/lib/models/playlist.model';
import {
  GpsOnly,
  Workout,
  Coaching,
  VideoSection,
  ApiHttpResponse,
} from '@kinomap-dev/ng-ui-lib';
import { Urls } from '@kinomap-dev/ng-ui-lib/lib/models/urls.model';
import { CoachingInterval } from '@kinomap-dev/ng-ui-lib/lib/models/coaching-interval.model';

export const convertApiMetaDataToVideo = (apiMetaData: any): VideoSection => {
  const apiData: any = apiMetaData.data;
  return convertApiDataToVideo(apiData);
};

export const convertApiDataToVideo = (apiData: any): VideoSection => {
  return apiData;
};

export const convertApiDataToPlaylist = (apiData: any): Playlist => {
  return apiData
};

export const convertApiDataToGpsTrack = (apiData: GpsOnly): GpsOnly => {
  return apiData;
};

export const convertApiDataToWorkout = (apiData: Workout): Workout => {
  return apiData;
};

export const convertApiMetaDataToCoaching = (
  apiMetaData: Coaching
): Coaching => {
  const apiData: Coaching = apiMetaData;
  return convertApiDataToCoaching(apiData);
};

export const convertApiDataToCoaching = (apiData: Coaching): Coaching => {
  return apiData;
};

export const convertApiDataToCoachingUrls = (apiData: Urls): Urls => {
  return {
    sd: apiData.sd ? apiData.sd : undefined,
    sd_secondary: apiData.sd_secondary ? apiData.sd_secondary : undefined,
    hd: apiData.hd ? apiData.hd : undefined,
    hd_secondary: apiData.hd_secondary ? apiData.hd_secondary : undefined,
    fhd: apiData.fhd ? apiData.fhd : undefined,
    fhd_secondary: apiData.fhd_secondary ? apiData.fhd_secondary : undefined,
    hls: apiData.hls ? apiData.hls : undefined,
  };
};

export const convertApiDataToCoachingDetails = (apiData: any): Coaching => {
  return {
    hardware: apiData.hardware,
    elevation_image_url: apiData.elevation_image_url,
    id: apiData.id,
    ratio: apiData.ratio,
    duration: apiData.duration,
    comments_count: apiData.comments_count,
    completion_percent: apiData.completion_percent,
    likes_count: apiData.likes_count,
    activities_completed: apiData.activities_completed,
    view_count: apiData.view_count,

    hash_id: apiData.hash_id,
    name: apiData.name,
    description: apiData.description ? apiData.description : null,
    status: apiData.status,
    sport: apiData.sport,
    access_type: apiData.access_type,
    recommended_audio: apiData.recommended_audio,
    recommended_mode: apiData.recommended_mode,
    difficulty_level: apiData.difficulty_level,
    equipment_type: apiData.equipment_type,

    sound_available: apiData.sound_available,
    is_favorite: apiData.is_favorite,
    has_liked: apiData.has_liked,
    has_disliked: apiData.has_disliked,
    has_commented: apiData.has_commented,

    qualities_available: apiData.qualities_available,

    created_at: apiData.created_at,

    type: BrowseTypesEnum.Coaching,
    lang: {
      code: apiData.lang.code.startsWith('en') ? 'en-EN' : apiData.lang.code,
      native_name: apiData.lang.native_name,
      id: apiData.lang.id,
      name: apiData.lang.name,
    },
    calories: {
      value: apiData.calories.value,
      unit: apiData.calories.unit,
    },
    author: apiData.author,

    urls: {
      sd: apiData.urls.sd ? apiData.urls.sd : null,
      sd_secondary: apiData.urls.sd_secondary
        ? apiData.urls.sd_secondary
        : null,
      hd: apiData.urls.hd ? apiData.urls.hd : null,
      hd_secondary: apiData.urls.hd_secondary
        ? apiData.urls.hd_secondary
        : null,
      fhd: apiData.urls.fhd ? apiData.urls.fhd : null,
      fhd_secondary: apiData.urls.fhd_secondary
        ? apiData.urls.fhd_secondary
        : null,
      hls: apiData.urls.hls ? apiData.urls.hls : null,
    },

    thumbnails: {
      small: apiData.thumbnails.small ? apiData.thumbnails.small : null,
      medium: apiData.thumbnails.medium ? apiData.thumbnails.medium : null,
      large: apiData.thumbnails.large ? apiData.thumbnails.large : null,
      xlarge: apiData.thumbnails.xLarge ? apiData.thumbnails.xLarge : null,
    },
  };
};

export const convertApiDataToCorrdinate = (apiData: any): Coordinate => {
  return {
    distance: apiData.distance,
    elevation: apiData.elevation,
    latitude: apiData.latitude,
    longitude: apiData.longitude,
    position: apiData.position,
    speed: apiData.speed,
    coo_time: apiData.coo_time,
    hearth_rate: apiData.hearth_rate,
  };
};

export const convertApiDataToInterval = (apiData: any): CoachingInterval => {
  return {
    time: apiData.time,
    value: apiData.value,
    percent: apiData.percent,
    type: apiData.type,
  };
};
